<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout class="eservice_inner_wrap login_wrap type2">
      <v-flex class="pa-0 login_content type2">
        <v-form>
          <v-card class="login_form type2 type3" flat>
            <h2 class="logo mb-25"><v-img src="~@/assets/img/logo_auth.png" alt="EGPO" @click="$router.push('/main')" style="cursor:pointer;"></v-img></h2>
            <h3 class="out_title mb-35">{{ $t('signup.title') }}</h3>

            <v-card-text class="pa-0 inner_item_content">
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-25 mt-25">
                  <h2 class="nec_title mb-15" style="text-align: center">{{ res_msg_en }}</h2>
                </v-col>
              </v-row>
              <v-row class="ma-0 btn_wrap pb-50">
                <v-btn class="sign_in_btn type2 type4" text style="margin: 0 auto" @click="fnGoMain()">{{ $t('common.button.ok') }}</v-btn>
              </v-row>
            </v-card-text>

          </v-card>
        </v-form>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'

export default {
  components: {
  },
  data () {
    return {
      res_msg_en : '',
      res_msg_ar : ''

    }
  },
  created () {
    this.$vuetify.rtl = false
    this.$i18n.locale = 'en'
    this.$vuetify.lang.current = 'en'
  },
  mounted () {
    window.scrollTo(0, 0)
    this.fnInit()
  },
  methods: {
    fnInit() {

      //url에서 마지막 단을 코드값으로 담아두자
      let codeParamArr = window.location.href.split("/")
      let code = codeParamArr[codeParamArr.length - 1]

      //추출한 코드가 유효한 값인지 확인 하고, 메세지 노출함
      requestApi({
        url: '/autho/verify/account/'+code,
        method: 'GET',
        callback: (res) => {
          this.res_msg_ar = res.res_msg_ar
          this.res_msg_en = res.res_msg_en
        }
      })
    },

    fnGoMain(){
      this.$router.push('/signup/usertype')
    }
  }
}
</script>